class NfeManifestoModal {
    constructor($scope, gql) {
        this.manifesto = { evento: "" }
        this.gql = gql
        this.apply = fun => $scope.$apply(fun)

        $scope.$watch(
            () => this.manifesto.evento,
            val => val && this.form.$setPristine()
        )
    }

    submit() {
        if (this.form.$valid) {
            const { nfesIds, empresaId } = this.resolve

            this.promise = this
                .manifestarNfes(empresaId, nfesIds, this.manifesto)
                .then(agendamentoId => {
                    this.agendamentoId = agendamentoId
                    Alert.info('Tarefa de manifestação agendada. Em breve você será notificado quando for finalizada.', 'Aviso', 15000)
                    this.close()
                })
                .catch(([error]) => {
                    if(error.message === 'every_nfes_already_has_manifesto') {
                        Alert.warning(`As NF-e informadas já possuem manifestação do evento <b>${this.getDescricaoEvento()}</b> vinculado.`, 'Aviso', 15000)
                    } else {
                        Alert.error("O sistema não conseguiu manifestar a NF-e com a RFB. Tente novamente mais tarde.", 'Erro', 15000)
                    }
                })
                .finally(() => this.apply())
        }
    }

    manifestarNfes(empresaId, nfesIds, manifesto) {
        const mutation = gql`
            mutation ManifestacaoNfes($empresaId: String!, $evento: EventoManifestacaoEnum!, $nfesIds: [String!], $justificativa: String) {
                empresa(id: $empresaId) {
                    agendamentoId: manifestarNfes(empresaId: $empresaId, nfesIds: $nfesIds, evento: $evento, justificativa: $justificativa)
                }
            }
        `

        const variables = {
            ...manifesto,
            empresaId: empresaId.toString(),
            nfesIds: nfesIds.map(nfeId => nfeId.toString())
        }

        return this.gql
            .mutate(mutation, variables)
            .then(({ empresa: { agendamentoId } }) => agendamentoId)
    }

    getDescricaoEvento() {
        switch (this.manifesto.evento) {
            case 'CONFIRMACAO':
                return 'Confirmação da operação'
            case 'NAO_REALIZADO':
                return 'Operação não realizada'
            case 'DESCONHECIMENTO':
                return 'Desconhecimento da operação'
        }
    }
}

angular.module('eficienciaFiscalModule')
    .component('nfeManifestoModal', {
        controller: ['$scope', 'gql', NfeManifestoModal],
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
        <form name="$ctrl.form" ng-submit="$ctrl.submit()" novalidate="novalidate">
            <div class="modal-header">
                <h3 class="modal-title">
                    Manifesto do destinatário
                    <i tooltip="Fechar" ng-click="$ctrl.close()" class="fa fa-times pull-right cursor-pointer"></i>
                </h3>
            </div>
            <div class="modal-body">
                <div class="clearfix smart-form">
                    <div class="form-group col-xs-12" style="margin-bottom: 10px">
                        <h3 style="margin-bottom: 20px;">
                            Escolha um tipo de manifesto
                        </h3>
                        <label class="radio" style="margin-bottom: 10px;">
                            <input type="radio" name="evento" ng-model="$ctrl.manifesto.evento" value="CONFIRMACAO" required>
                            <i></i> Confirmação da operação </br>
                            <p class="text-muted">
                                Com este manifesto, o destinatário confirma que a operação descrita na NF-e 
                                ocorreu exatamente da forma como foi informada pelo emissor.
                            </p>
                        </label>
                        <label class="radio" style="margin-bottom: 10px;">
                            <input type="radio" name="evento" ng-model="$ctrl.manifesto.evento" value="NAO_REALIZADO" required>
                            <i></i> Operação não realizada </br>
                            <p class="text-muted">
                                Com este manifesto, o destinatário reconhece a sua participação na operação informada na NF-e, porém 
                                declara que a mesma não ocorreu exatamente como foi informado pelo emissor.
                            </p>
                        </label>
                        <label class="radio" style="margin-bottom: 10px">
                            <input type="radio" name="evento" ng-model="$ctrl.manifesto.evento" value="DESCONHECIMENTO" required>
                            <i></i> Desconhecimento da operação </br>
                            <p class="text-muted">
                                Com este manifesto, o destinatário declara que essa operação não foi efetuada com seu conhecimento ou consentimento.
                            </p>
                        </label>
                        <div ng-messages="$ctrl.form.evento.$error" ng-if="$ctrl.form.$submitted">
                            <span class='help-block txt-color-red font-xs no-margin' ng-message="required"> Selecione um tipo de manifesto acima para prosseguir.</span>
                        </div>
                    </div>
                    <div
                        ng-if="$ctrl.manifesto.evento == 'NAO_REALIZADO'"
                        class="form-group col-xs-12 slide-animation"
                        style="margin-bottom: 15px;">
                        <h3 style="margin-bottom: 20px;">
                            Escreva uma justificativa 
                            <small><i>(Mínimo 15 caracteres)</i></small>
                        </h3>
                        <input 
                            type="text" 
                            name="justificativa" 
                            ng-model="$ctrl.manifesto.justificativa"
                            ng-minlength="15" 
                            ng-maxlength="255" 
                            class="form-control" 
                            required/>
                        <div ng-messages="$ctrl.form.justificativa.$error" ng-messages-multiple="ng-messages-multiple"
                             ng-messages-include="erros-validacao" ng-if="$ctrl.form.$submitted">
                             <span ng-message="minlength" class="help-block txt-color-red font-xs no-margin">
                                A justificava deve conter 15 ou mais caracteres.
                             </span>
                             <span ng-message="maxlength" class="help-block txt-color-red font-xs no-margin">
                                A justificava deve conter 255 ou menos caracteres.
                            </span>
                        </div>
                    </div>
                    <div ng-if="$ctrl.resolve.nfesIds.length > 1 && $ctrl.manifesto.evento" class="text-center text-danger">
                        <h3>Esta ação irá manifestar {{ $ctrl.resolve.nfesIds.length }} notas com o evento <br/>{{ $ctrl.getDescricaoEvento() }}.</h3>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <promise-tracker promise="$ctrl.promise" active="$ctrl.isLoading">
                    <button type="submit" ng-disabled="$ctrl.isLoading" class="btn btn-primary">
                        <span ng-hide="$ctrl.isLoading" >Manifestar NF-e</span>
                        <span ng-show="$ctrl.isLoading"><i class="fa fa-circle-o-notch fa-spin"></i> Manifestando NF-e...</span>
                    </button>
                </promise-tracker>
                <button type="button" ng-click="$ctrl.close()" class="btn btn-default">Fechar</button>
            </div>
        </form>
        `
    })
